import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { CampaignTemplates } from '../../containers/templates/CampaignTemplates';

export const AdminCampaignsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<CampaignTemplates />
		</AdminDashboardPageLayout>
	);
};
